<template>
    <div class="container-fluid container-full">
        <div class="row">
            <div class="col-md-3 profile-column"></div>
            <div class="col-md-6">
                <div class="card card-sidebar">
                    <div v-show="rights.A_PAYM" class="card-block" align="justify">
                        <div class="headline-box">
                            <span class="headline">
                                Thanks so much for testing Leapsome!
                            </span>
                        </div>
                        Your free trial has just expired - to continue using Leapsome, please update
                        your billing information. If you have any questions or feedback, please do
                        get in touch via our support form or
                        <a href="https://calendly.com/jenny-podewils-leapsome/30min" target="_blank"
                            >schedule a quick call</a
                        >. Need another look? Here's a
                        <a href="https://www.leapsome.com/en/presentation-tech" target="_blank"
                            >link to our presentation</a
                        >. We're always looking forward to your feedback!
                        <div class="text-center">
                            <br />
                            <a class="btn btn-primary btn-raised" href="#/team/settings/billing">
                                Purchase now
                            </a>
                        </div>
                    </div>
                    <div v-show="!rights.A_PAYM" class="card-block" align="justify">
                        {{ user.firstname }} - It's fantastic to have you on board! Your free trial
                        has just expired - to continue using Leapsome, please ask your account owner
                        to update your billing information. Also feel free to get in touch via our
                        support form. We're always looking forward to your feedback!
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            user: "users/current/user",
            rights: "users/current/rights",
        }),
    },
};
</script>

<style scoped></style>
